import { computed } from 'vue'

import type {
  UseGalleryLayoutParams,
  UseGalleryLayoutResult,
} from '~/scopes/product-core/components/presentationals/ProductDetailPageGallery/composables/useGalleryLayout/useGalleryLayout.types'
import {
  buildDesktopGalleryLayout,
  buildMobileGalleryLayout,
} from '~/scopes/product-core/components/presentationals/ProductDetailPageGallery/composables/useGalleryLayout/useGalleryLayout.utils'

export function useGalleryLayout({
  baseImages,
  injectableItems,
}: UseGalleryLayoutParams): UseGalleryLayoutResult {
  const mobileItems = computed(() =>
    buildMobileGalleryLayout({
      baseImages: baseImages.value,
      injectableItems: injectableItems.value,
    }),
  )
  const desktopItems = computed(() =>
    buildDesktopGalleryLayout({
      baseImages: baseImages.value,
      injectableItems: injectableItems.value,
    }),
  )

  return {
    mobileItems,
    desktopItems,
  }
}
